import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { ChevronDown } from '@src/components/atoms/icons/chevron-down';
import { ChevronUp } from '@src/components/atoms/icons/chevron-up';
import { Button } from '@src/components/atoms/inputs/button';
import { TripPreviewCard } from '@src/components/organisms/trip-preview-card';
import { useCmsContent } from '@src/contexts/cms-content-context';
import { TripListItemProvider } from '@src/contexts/trip-list-item-context/trip-list-item-context';
import { useIsMobile } from '@src/hooks/use-is-mobile';

import { UpcomingTripsHomeProps } from './types';

import styles from './upcoming-trips-home.module.css';

const UpcomingTripsHome = ({ upcomingTrips }: UpcomingTripsHomeProps) => {
  const content = useCmsContent();
  const [isShowingAllTrips, setIsShowingAllTrips] = useState(false);
  const isMobile = useIsMobile();
  const { numberOfTripsToShow, tripsToShow } = useMemo(() => {
    const TRIPS_TO_SHOW = 2;
    const numberOfTripsToShow = upcomingTrips.length - TRIPS_TO_SHOW;
    const tripsToShow = isShowingAllTrips ? upcomingTrips : upcomingTrips.slice(0, TRIPS_TO_SHOW);

    return {
      numberOfTripsToShow,
      tripsToShow,
    };
  }, [upcomingTrips, isShowingAllTrips]);

  const onMoreTripsClicked = () => {
    if (isShowingAllTrips && isMobile) {
      setTimeout(() => window.scrollTo(0, 0), 20);
    }
    setIsShowingAllTrips((isShowingAllTrips) => !isShowingAllTrips);
  };
  return (
    <div className={styles.upcomingTripsListContent}>
      <div className={styles.upcomingTripsHeading}>
        <FormattedMessage
          id="upcomingTripsHeading"
          defaultMessage={content.upcomingTripsHeading}
          values={{ trips: upcomingTrips.length, plural: upcomingTrips.length > 1 }}
        />
      </div>

      {tripsToShow.map((trip) => (
        <TripListItemProvider value={{ trip }} key={trip.id}>
          <TripPreviewCard />
        </TripListItemProvider>
      ))}

      {numberOfTripsToShow > 0 && (
        <Button className={styles.moreTripsButton} onClick={onMoreTripsClicked} variant="secondary">
          {isShowingAllTrips ? (
            <>
              <span>{content.seeLess}</span>
              <ChevronUp />
            </>
          ) : (
            <>
              <FormattedMessage
                id="seeMoreTrips"
                defaultMessage={content.seeMoreTrips}
                values={{ trips: numberOfTripsToShow }}
              />
              <ChevronDown />
            </>
          )}
        </Button>
      )}
    </div>
  );
};

export default UpcomingTripsHome;
